import { ValidatorRules } from '../../../../util/validator'
import { StrategyStepState } from '../strategy-slice'

export const leverageConstantProportionRules: ValidatorRules<StrategyStepState> = {}
